"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSyncValidate = exports.isSyncTransform = void 0;
const isSyncTransform = transform => {
  return transform.length === 1;
};
exports.isSyncTransform = isSyncTransform;
const isSyncValidate = validate => {
  return validate.length === 1;
};
exports.isSyncValidate = isSyncValidate;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJpc1N5bmNUcmFuc2Zvcm0iLCJ0cmFuc2Zvcm0iLCJsZW5ndGgiLCJleHBvcnRzIiwiaXNTeW5jVmFsaWRhdGUiLCJ2YWxpZGF0ZSJdLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy90eXBlcy50cyJdLCJzb3VyY2VzQ29udGVudCI6W251bGxdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBb0JPLE1BQU1BLGVBQWUsR0FDeEJDLFNBQXFDLElBQ0E7RUFDckMsT0FBT0EsU0FBUyxDQUFDQyxNQUFNLEtBQUssQ0FBQztBQUNqQyxDQUFDO0FBSllDLE9BQUEsQ0FBQUgsZUFBZSxHQUFBQSxlQUFBO0FBWXJCLE1BQU1JLGNBQWMsR0FBbUJDLFFBQXdCLElBQW9DO0VBQ3RHLE9BQU9BLFFBQVEsQ0FBQ0gsTUFBTSxLQUFLLENBQUM7QUFDaEMsQ0FBQztBQUZZQyxPQUFBLENBQUFDLGNBQWMsR0FBQUEsY0FBQSIsImlnbm9yZUxpc3QiOltdfQ==